define('modules/form/radio_view',[
  'backbone',
  'jquery',
  '_',

  './form_item_view',
  'modules/form/convert-form-data',

  'text!./radio_template.html',
  'text!modules/form/media_fact_connection/media_fact_connection_template.html',
], function (
  Backbone,
  $,
  _,
  FormItemView,
  convertFormData,
  template,
  media_fact_connection_template
) {
  'use strict';
  var View = FormItemView.extend({
    initialize: function (options) {
      _.extend(this, options);

      this.listenTo(this.model, 'change', this.renderMediaFactConnection);

      FormItemView.prototype.initialize.apply(this, options);

      var values = {};
      values[this.model.get('name')] = this.getValues();

      this.dataModel.set(values);
      this.dataModelAttributesOriginal = _.cloneDeep(this.dataModel.attributes);

      this.render();
      this.renderMediaFactConnection();
      this.checkForAction();
    },
    media_fact_connection_template: _.template(media_fact_connection_template),
    template: _.template(template),
    events: {
      'change input': 'inputChange',
    },

    getValues: function () {
      var values = [];

      _.forEach(this.model.get('options'), function (option) {
        if (option.state === 'active') {
          values.push(option.value);
        }
      });
      return values[0];
    },

    checkForAction: function () {
      var that = this;
      // Wait for view to render
      setTimeout(function () {
        _.forEach(that.model.get('options'), function (option) {
          if (option.state === 'active') {
            switch (option.action) {
              case 'showSwedishLabel':
                that.showSwedishLabel();
                break;
              case 'hideSwedishLabel':
                that.hideSwedishLabel();
                break;
            }
          }
        });
      }, 1);
    },

    inputChange: function (e) {
      if (e.target.attributes['action-showSwedishLabel']) {
        this.showSwedishLabel();
      }
      if (e.target.attributes['action-hideSwedishLabel']) {
        this.hideSwedishLabel();
      }
      this.dataModel.set(
        convertFormData(
          this.$('[name="' + e.target.name + '"]').serializeArray()
        )
      );
    },

    showSwedishLabel: function () {
      $('.swedish-label').show();
    },

    hideSwedishLabel: function () {
      $('.swedish-label').hide();
    },

    renderMediaFactConnection: function () {
      this.$('.js-media-fact-connection').html(
        this.media_fact_connection_template(this.model.attributes)
      );
      return this;
    },

    render: function () {
      this.$el.html(this.template(this.model.toJSON()));
      return this;
    },

    remove: function () {
      this.$el.off();
      this.$el.remove();
      this.stopListening();
      return this;
    },
  });
  return View;
});

